<template>


    <div>

        <h1 class="mapTitle page-title" v-if="userProfile.fullName">
            {{userProfile.fullName}} <span class="fw-semi-bold">Trips</span>
        </h1>
        <h1 class="mapTitle page-title" v-else>
            Explore <span class="fw-semi-bold">Trips</span>
        </h1>


        <div class="mapContainer">
            <div id="map" style="width: 100%; height: inherit;"></div>
        </div>


        <b-card class="mb-xlg  " id="tripDetailsOverMap" v-if="selectedTrip">


            <b-card-header>

                <b-container>
                    <b-row>
                        <b-col class="col-sm">
                            <h4 class="title"> {{ selectedTrip.short_desc}}
                                <small>( {{selectedTripLengthKM}} Km )</small>
                            </h4>


                            <Likes :object-id="selectedTrip.id"></Likes>

                        </b-col>
                        <b-col class="col-sm">
                            <a @click="$router.push('/users/' + selectedTrip.uid)">
                  <span class="avatar thumb-sm float-left mr-2">
                    <img class="rounded-circle" :src="selectedTrip.profilePicture" :alt="selectedTrip.fullName"/>
                  </span>
                                <span class="small">{{selectedTrip.fullName}}
                                    <!--                        <span class="fw-semi-bold">Smith</span>-->
                    </span>
                            </a>
                            <br>
                            Published
                            <timeago :datetime="selectedTrip.createdOn |unixToDate" :auto-update="60"></timeago>
                            <ul class="post-links mt-sm pull-left">

                                <li>
                                    <a class="text-primary" @click="$router.push('/explore/map/' + selectedTrip.uid)">
                                        <i class="la la-map la-lg"></i>View user map
                                    </a>

                                </li>
                                <li>
                                    <a class="text-primary" @click="$router.push('/users/' + selectedTrip.uid)">
                                        <i class="la la-person la-lg"></i>View profile
                                    </a>

                                </li>
                            </ul>

                        </b-col>
                        <b-col class="col-sm">
                            <a class="px-2 float-right" @click="tripDetailsClose">
                                <i class="la la-times la-lg"/>
                            </a>

                            <b-button variant="info" class="btn-sm" v-if="selectedTrip && canEditSelectedTrip" @click="openEditTrip">
                                Edit Trip
                            </b-button>

                            <b-button variant="danger" class="btn-sm" v-if="selectedTrip && canEditSelectedTrip" @click="openDeleteTrip()">
                                Delete Trip
                            </b-button>


                        </b-col>
                    </b-row>
                </b-container>


            </b-card-header>


            <div>

                <div class="thumbnail-container">
                    <ul class="thumbnail-list">
                        <li v-for="(slide, i) in lightBoxImages">
                                <span>
                                    <img

                                            :alt="slide.capturedOn"
                                            class="thumbnail-image"
                                            v-bind:class="{ 'image-have-position': imageHavePosition(slide) }"

                                            v-lazy="slide.thumb"

                                            @mouseover="tripDetailsImageMouseOver(slide)"
                                            @click="tripDetailsImageClick(slide)">
                                </span>
                        </li>
                    </ul>
                </div>


            </div>

        </b-card>

        <ShowPhotosModal
                ref="popupShowMedia"
                :images="lightBoxImages"
                :index="lightBoxSelectedImageIndex"
                :trip="selectedTrip"
                v-on:image-changed="onLightBoxImageChanged"
                v-on:close="onShowPhotosModalClose"
        >
        </ShowPhotosModal>


        <trip-edit
                ref="tripEdit"
                v-on:close="onEditTripClose">
        </trip-edit>


    </div>

</template>


<script>
  import gmapsInit from '../googleMapsConfig'

  import TripEdit from './TripEdit'
  import { mapState } from 'vuex'

  import Likes from '@/components/Likes/Likes'

  import PhotoSelector from './PhotosSelector'
  import CommentsThread from '@/components/Comments/CommentsThread'
  import LightBox from '@/components/LightBox/LightBox'
  import ShowPhotosModal from '@/components/ShowPhotosModal/ShowPhotosModal'

  import UIHelpersMixins from '../mixims/UIHelpersMixins'

  const TRIP_TYPES = require('@/components/Trips/TripTypes.js')

  const fb        = require('../firebaseConfig.js')
  const CommonLib = require('../lib/Common')

  //////////////////////////////////////////////////////////////////////////
  // In your VueJS component.
  //  import { VueperSlides, VueperSlide } from 'vueperslides'

  // Since v. 1.6.0, you need to include Vueper Slides CSS file for default styles.
  //  import 'vueperslides/dist/vueperslides.css'
  //////////////////////////////////////////////////////////////////////////
  import swal from 'sweetalert2'

  //////////////////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////////////////

  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

  //////////////////////////////////////////////////////////////////////////
  import Vue from 'vue'
  import VueLazyload from 'vue-lazyload'

  Vue.use(VueLazyload)
  //////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////

  export default {
    mixins:
                [
                  UIHelpersMixins,
                ],
    components: {
      Likes,
      TripEdit,
      CommentsThread,
      ShowPhotosModal,
      //   VueperSlides,
      //VueperSlide,
      'photoSelector': PhotoSelector,
      'LightBox':      LightBox,
    },
    props:      [
      'selectedUserId',
      'selectedTripId', // From URL
      'selectedMediaID',  // From URL
    ],
    data ()
    {
      return {
        userProfile: {},

        lightBoxImages:             [],
        lightBoxSelectedImageIndex: 0,

        imageId: null,

        alert: false,

        displayed_markers: [],
        trips:             [],

        map: null,
      }
    },

    beforeCreate: function () {

    },
    mounted ()
    {
      var that = this

      gmapsInit().then(function () {

        that.initMap()

        that.displayTrips().then(function () {
          that.handleDisplayPopups(that.$router.currentRoute)

        })
      })

    },
    computed:     {

      currentUser ()
      {
        return this.$store.getters.currentUser
      },

      selectedTrip ()
      {
        return this.$store.getters.selectedTrip
      },

      isAuthenticated ()
      {
        return this.currentUser !== null || this.currentUser !== undefined
      },

      error ()
      {
        return this.$store.state.error
      },
      loading ()
      {
        return this.$store.state.loading
      },
      selectedTripLengthKM ()
      {

        if (!this.selectedTrip || !this.selectedTrip.route_lengthMeters)
        {
          return 0
        }

        var km = this.selectedTrip.route_lengthMeters / 1000
        if (km > 100)
        {
          return Number((km).toFixed(0))
        }

        return Number((km).toFixed(1))
      },
      canEditSelectedTrip ()
      {
        return this.currentUser
          && this.selectedTrip
          && this.currentUser.uid === this.selectedTrip.uid
      },
    }, // computed

    methods: {

      openEditTrip ()
      {
        this.$router.push('/explore/trips/' + this.selectedTrip.id + '/edit')
        this.$refs.tripEdit.show()

      },
      openDeleteTrip ()
      {
        var that = this
        swal({
          title:              'Are you sure?',
          text:               'Are you sure you want to delete ' + this.selectedTrip.short_desc + ' ?',
          type:               'warning',
          showCancelButton:   true,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass:  'btn btn-success',
          confirmButtonText:  'Yes, delete it!',
          buttonsStyling:     false
        }).then((result) => {
          if (result.value)
          {
            that.deleteTrip(this.selectedTrip)
          }

        })
      },
      deleteTrip: function (trip) {

        var key   = trip.id
        var title = trip.short_desc

        var that = this
        fb.tripsCollection.doc(key).delete().then(function () {

          that.notifyVue('success', title + ' Deleted!')

          that.$store.commit('setSelectedTrip', null)
          that.displayTrips()

          fb.mediasCollection.where('tripId', '==', key)
            .onSnapshot(function (querySnapshot) {

              querySnapshot.forEach(function (img) {
                fb.mediasCollection.doc(img.id).delete().then(function () {

                  that.notifyVue('success', 'Deleted image!')
                }).catch(function (error) {
                  console.error('Error removing document: ', error)
                })

              })
            })

        }).catch(function (error) {
          console.error('Error removing document: ', error)
        })

        //this.resetForm()

      },

      tripDetailsClose ()
      {
        this.$store.commit('setSelectedTrip', null)
        this.$router.push('/explore')

      },

      imageHavePosition (image)
      {
        return Math.abs(image.latitude) > Number.EPSILON &&
          Math.abs(image.longitude) > Number.EPSILON
      },

      tripDetailsImageClick (image)
      {
        this.$refs.popupShowMedia.show(image.index)
        this.$router.push('/explore/trips/' + image.tripId + '/media/' + image.id)
      },

      onLightBoxImageChanged (image)
      {
        //   this.$refs.popupShowMedia.show(image.index)
        this.$router.push('/explore/trips/' + image.tripId + '/media/' + image.id)
      },
      onShowPhotosModalClose ()
      {
        this.$router.push('/explore/trips/' + this.selectedTrip.id)
      },

      tripDetailsImageMouseOver (image)
      {
        if (this.imageHavePosition(image))
        {
          const marker = new google.maps.LatLng(image.latitude, image.longitude)

          this.map.panTo(marker)
        }
      },

      initMap ()
      {
        // Regular Map
        const myLatlng   = new google.maps.LatLng(40.748817, -73.985428)
        const mapOptions = {
          zoom:                   6,
          center:                 new google.maps.LatLng(45.7, -73.90),
          mapTypeId:              google.maps.MapTypeId.TERRAIN,
          zoomControl:            false,
          mapTypeControl:         true,
          scaleControl:           false,
          panControl:             false,
          fullscreenControl:      true,
          navigationControl:      false,
          disableDoubleClickZoom: true,
          streetViewControl:      false,
          mapTypeControlOptions:  {
            style:      google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID,
              google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN]
          },
          scrollwheel:            true,
          draggableCursor:        'crosshair',
          animation:              google.maps.Animation.BOUNCE,
          gestureHandling:        'greedy',
          styles:                 [{
            'featureType': 'poi.attraction',
            'stylers':     [{
              'visibility': 'off'
            }]
          },
            {
              'featureType': 'poi.business',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.medical',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.place_of_worship',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.school',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'transit.station.bus',
              'stylers':     [{
                'visibility': 'off'
              }]

            }
          ]
        }

        this.map = new google.maps.Map(document.getElementById('map'), mapOptions)

      },
      sanitizeDbTrip: function (doc) {

        var trip        = doc.data()
        trip            = trip || {}
        trip.id         = doc.id || null
        trip.uid        = trip.uid || ''
        trip.short_desc = trip.short_desc || ''
        trip.type       = trip.type || ''

        trip.poly               = trip.poly || []
        trip.route_segments     = trip.route_segments || []
        trip.route_lengthMeters = trip.route_lengthMeters || 0

        return trip
      },

      getColor:                function (index, trip_type) {

        // var i = Object.keys(TRIP_TYPES.types).findIndex(function (element) {
        //   return element.toLowerCase() === trip_type.toLowerCase()
        // })

        // switch (trip_type)
        // {
        //   case  'Other':
        //   case '':
        //   default:
        //     return '#6e27d2'
        //   case 'DRIVING':
        //     return '#ff9e9e'
        //   case 'WALKING':
        //     return '#d2d015'
        //   case 'BICYCLING':
        //     return '#d236c0'
        //   case 'TRANSIT':
        //     return '#6e27d2'
        //   case 'Backpacking':
        //   case 'Walking':
        //     return '#d2d015'
        //   case 'Driving':
        //     return '#ff9e9e'
        //   case 'Bicycling':
        //     return '#d236c0'
        //   case 'Camping':
        //   case 'Canoeing':
        //   case 'Cycling':
        //     return '#d236c0'
        //   case 'Cyclo-touring':
        //     return '#d236c0'
        //   case 'Road-Trip':
        //     return '#ff9e9e'
        //   case 'Rock climbing':
        //   case 'Running':
        //     return '#d2d015'
        //
        //   case 'Sailing':
        //   case 'Snowboarding':
        //     return '#d2d015'
        //
        //   case 'Trekking':
        //     return '#d2d015'
        //
        // }

        var colors = [
          '#6e27d2', '#338cc8', '#714908', '#de0ca0',
          '#e2b265', '#12fb8d', '#d35545', '#99b0e9',
          '#e000e7', '#d28d94', '#a42445', '#e1e45b',
          '#58a76b', '#1793f6', '#eb26fa', '#8e7d78',
          '#d4120d', '#015359', '#814226', '#b58cd9',
          '#4d791f', '#4a5103', '#9daf4b', '#70f16a',
          '#7e58d8', '#431d8f', '#f1cc7c', '#6578ad',
          '#2d7a74', '#ec35fa', '#01b689', '#47f387',
          '#038718', '#e739ea', '#c8c81b', '#ebecba',
          '#73c99b', '#7c6eac', '#629464', '#e25114']

        return colors[index % colors.length]
      },
      displayTrips:            function () {
        let that = this

        return new Promise(function (resolve, reject) {

          that.trips.forEach(function (trip, value) {

            trip.gpPoly.setMap(null)

            trip.gpRoute_segments.forEach(function (gpSegment, value) {

              gpSegment.setMap(null)
            })
          })

          that.trips = []

          var ref = fb.tripsCollection

          if (that.$router.currentRoute.params.selectedUserId)
          {
            ref = ref.where('uid', '==', that.$router.currentRoute.params.selectedUserId)
          } else
          {
            //ref = ref.limit(75)
          }

          ref.onSnapshot(querySnapshot => {
            var i = 0
            console.log('Store ->> setTrips ' + querySnapshot.docs.length)

            var requestedTripIdFound = false

            querySnapshot.forEach(function (doc) {
              if (that.$router.currentRoute.params.selectedTripId && doc.id === that.$router.currentRoute.params.selectedTripId)
              {
                requestedTripIdFound = true
              }
              that.displayTrip(doc, ++i)
            })

            if (that.$router.currentRoute.params.selectedTripId && !requestedTripIdFound)
            {
              fb.tripsCollection.doc(that.$router.currentRoute.params.selectedTripId).onSnapshot(doc => {
                that.displayTrip(doc, ++i)
              })
            }

            resolve()
          })
        })
      },
      displayTrip (doc, tripIndex)
      {
        let that = this

        let trip = that.sanitizeDbTrip(doc)

        if (trip.poly.length === 0)
        {
          return
        }

        var gpPoly = new google.maps.Polyline({
          clickable: true,
          path:      google.maps.geometry.encoding.decodePath(trip.poly),
        })

        var gpRoute_segments = []
        gpPoly.REL_TRIP_ID   = trip.id

        trip.gpPoly = gpPoly

        trip.route_segments.forEach(function (segment, segmentIndex) {
          var gpSegment_poly = new google.maps.Polyline({
            clickable:    true,
            strokeColor:  that.getColor(tripIndex, trip.type),
            strokeWeight: 4,
            path:         google.maps.geometry.encoding.decodePath(segment),
            map:          that.map,
          })

          gpSegment_poly.REL_TRIP_ID = trip.id

          gpRoute_segments[segmentIndex] = gpSegment_poly

          google.maps.event.addListener(gpSegment_poly, 'click', function (event) {

            console.log('poly segment click')

            //    that.$store.commit('setSelectedTrip', trip)
            that.$router.push('/explore/trips/' + trip.id)

          })
        })

        trip.gpRoute_segments = gpRoute_segments

        if (trip.id && trip.id === that.$router.currentRoute.params.selectedTripId)
        {
          that.$store.commit('setSelectedTrip', trip)
        }

        that.trips.push(trip)

      },
      hideAllTripMediaMarkers: function () {

        this.displayed_markers.forEach(function (key, value) {
          key.setMap(null)
        })
        this.displayed_markers = []
        this.lightBoxImages    = []

      },

      displayMediaMarkers: function (tripId) {
        // Photos
        var that = this

        fb.mediasCollection.where('tripId', '==', tripId).orderBy('capturedOn', 'asc')
          .onSnapshot(function (querySnapshot) {

            that.lightBoxImages = []
            querySnapshot.forEach(function (doc) {

              if (!doc.data().thumbsPath || !doc.data().thumbsPath[1600])
              {
                return
              }

              var faces      = doc.data().metadata.faces
              var latitude   = doc.data().metadata.latitude
              var longitude  = doc.data().metadata.longitude
              var capturedOn = doc.data().capturedOn

              var caption = doc.data().metadata.name
              if (doc.data().labels && doc.data().labels.length)
              {
                caption = '<p>Tags: '
                doc.data().labels.forEach(function (l) {
                  caption += '<a href="/labels/' + l + '">' + l + '</a> '
                })
              }

              let imgIndex = that.lightBoxImages.length

              var image = {
                id:          doc.id,
                uid:         doc.data().uid,
                tripId:      doc.data().tripId,
                index:       imgIndex,
                thumb:       CommonLib.getImageURL(doc.data().thumbsPath[128]),
                src:         CommonLib.getImageURL(doc.data().thumbsPath[1600]),
                latitude:    latitude,
                longitude:   longitude,
                faces:       faces,
                capturedOn:  capturedOn,
                caption:     caption,
                description: doc.data().description || '',
                metadata:    doc.data().metadata,
              }
              that.lightBoxImages.push(image)

              if (image.id === that.$router.currentRoute.params.selectedMediaID) // @todo Find the correct way to make deep route work
              {
                that.tripDetailsImageClick(image)
              }

              if (latitude && longitude)
              {
                var icon = google.maps.SymbolPath.CIRCLE

                var marker = new google.maps.Marker({
                  position:  {lat: latitude, lng: longitude},
                  map:       that.map,
                  // title:     'Hello World!',
                  visible:   true,
                  clickable: true,
                  // icon:      doc.data().signedURLs[128],
                  icon:      {
                    path:  icon,
                    scale: 3
                  },
                  alpha:     0.5,
                  // shadow:    'http://www.mysite.com/markershadow.png'
                })

                google.maps.event.addListener(marker, 'click', function () {
                  that.$refs.popupShowMedia.show(imgIndex)
                })

                that.displayed_markers.push(marker)

              }

            })
          })
      },
      highlightSelectedTrip (lastRoute)
      {
        var that     = this
        var lastTrip = lastRoute ? this.trips.find(trip => trip.id === lastRoute.params.selectedTripId) : null

        var defaultStroke = 4
        if (this.selectedTrip)
        {
          defaultStroke = 2
        }

        this.trips.forEach(function (trip) {
          trip.gpRoute_segments.forEach(function (poly) {
            poly.setOptions({strokeWeight: defaultStroke})
          })
        })

        //
        // if (lastTrip)
        // {
        //   lastTrip.gpRoute_segments.forEach(function (poly) {
        //     poly.setOptions({strokeWeight: 4})
        //   })
        // }

        if (this.selectedTrip)
        {
          var bounds = new google.maps.LatLngBounds()

          this.selectedTrip.gpRoute_segments.forEach(function (gpSegment) {
            gpSegment.setOptions({strokeWeight: 7})

            gpSegment.getPath().forEach(function (k, v) {
              bounds.extend(k)
            })
          })

          that.map.fitBounds(bounds)
        }
      },
      handleDisplayPopups: function (currentRoute, lastRoute) {
        var that = this
        console.log('Current Route : ' + currentRoute.name)

        /// @todo  OK.. This is not how it should be done, but its working for now !
        if (currentRoute.name === 'Add Trip')
        {
          this.$store.commit('setSelectedTrip', null)

          this.$refs.tripEdit.show()

        } else if (currentRoute.name === 'TripEdit')
        {
          this.$refs.tripEdit.show()
        } else if (currentRoute.name === 'Explore Trips')
        {
          if (lastRoute && currentRoute.params.selectedUserId !== lastRoute.params.selectedUserId)
          {
            that.userProfile = {}
            this.displayTrips().then(function () {

              that.$store.dispatch('userProfiles/retreiveProfile', currentRoute.params.selectedUserId).then(function (userProfile) {

                that.userProfile = userProfile
              }).catch(function (err) {
                console.log(err)
              })

            })
          }

          this.$store.commit('setSelectedTrip', null)

          this.highlightSelectedTrip(lastRoute)

        } else if (currentRoute.name === 'Explore Trip')
        {
          var trip = this.trips.find(trip => trip.id === currentRoute.params.selectedTripId)

          this.$store.commit('setSelectedTrip', trip)

          this.highlightSelectedTrip(lastRoute)

        } else if (currentRoute.name === 'View Media')
        {
          // handling done when loading images
        }

      },

      onEditTripClose ()
      {

        if (this.selectedTrip)
        {
          this.$router.push('/explore/trips/' + this.selectedTrip.id)
        } else
        {
          this.$router.push('/explore')
        }

        this.displayTrips()
      },
    }, // methods

    watch: {
      $route (to, from)
      {
        console.log('WATCH ROUTE TO : ', to)

        this.handleDisplayPopups(to, from)
      },

      'selectedTrip':

        function (val, previousTrip) {
          var that = this
          console.log('WATCH: selectedTrip')

          this.hideAllTripMediaMarkers()

          if (val)
          {
            console.log('Selected : ' + val.id)

            //if(this.selectedTripId !==val.id)
            //{
            //}

            that.$store.dispatch('userProfiles/retreiveProfile', val.uid).then(function (userProfile) {

              val.profilePicture = userProfile.profilePicture
              val.fullName       = userProfile.fullName

            }).catch(function (err) {
              console.log(err)
            })

            this.displayMediaMarkers(val.id)
          }
        },
      error (value)
      {
        if (value)
        {
          this.alert = true
        }
      }
      ,
      alert (value)
      {
        if (!value)
        {
          this.$store.commit('setError', null)
        }
      }
    }
  }
</script>


<style type="scss" scoped>
    .mapContainer {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 100%;
    }

    .mapTitle {
        position: relative;
        z-index: 2;
    }

</style>
<style scoped>

    .card-body {
        padding: 0;
    }

    .image-have-position {
        border: 1px solid #021f55;
    }

    .thumbnail-container {
        overflow-x: scroll;
        width: 100%;
        padding: 0 15px;
    }

    .thumbnail-list {
        white-space: nowrap;
        list-style: none;
        margin: 0;
        padding: 0;

    }

    .thumbnail-list li {
        display: inline-block;
    }

    .thumbnail-image {
        display: block;
        padding: 2px;
        max-width: 128px;
        max-height: 96px;
        min-width: 100px;
        height: auto;
    }


    #tripDetailsOverMap {
        position: absolute;
        width: 60%;
        left: 20%;
        bottom: 10px;
        z-index: 10;
    }

    @media (max-width: 1200px) {
        #tripDetailsOverMap {
            margin: 0 0;
            width: 100%;
            left: 0;
            bottom: 0;
        }
    }

</style>
